<template>
    <v-card class="px-0 primary darken-1">
        <v-card-title v-if="!showInMap">
            <v-row>
                <v-spacer class="d-none d-sm-flex"></v-spacer>
                <v-col cols="12" sm="4">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-title>
        <v-data-table
            id="data-table-rain-forecast"
            class="primary darken-1"
            :headers="headers"
            :items="items"
            :search="search"
            :hide-default-footer="showInMap"
            :disable-sort="items.length == 1"
            mobile-breakpoint="0"
        >
            <template v-slot:header="{}">
                <thead class="white--text">
                    <th v-if="!showInMap" class="header-rain-table">#</th>
                    <th id="header-estimation-rain-table" class="header-rain-table" :colspan="minDaysForecast + 1">Estimativa</th>
                    <th id="header-prevision-rain-table" class="header-rain-table" :colspan="maxDaysForecast + 1">Previsão</th>
                </thead>
                <div style="height: 4px;"></div>
            </template>

            <template v-slot:body="{ items }">
                <tbody>
                    <tr
                        v-for="(item,index) in items"
                        :key="index"
                        class="primary darken-1"
                    >
                        <td class="item-rain-table" v-for="(key, indexColumn) in Object.keys(item)" :key="indexColumn" >{{item[key]}}</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-card>

</template>

<script>
import {eachDayOfInterval, subDays, addDays, format, parseISO, isEqual} from 'date-fns';
export default {
    name: 'RainEstimationTable',
    props:{
        locations: {
            type: Array,
            required: true
        },
        forecasts: {
            type: Array,
            required: true
        },
        siprecDailyEstimated: {
            type: Array,
            required: true
        },
        minDaysForecast:{
            type: Number,
            required: true
        },
        maxDaysForecast:{
            type: Number,
            required: true
        },
        selectorClassColor:{
            type: String,
            default: () => "primary"
        },
        estimationClassColor:{
            type: String,
            default: () => "primary darken-1"
        },
        forecastClassColor:{
            type: String,
            default: () => "primary darken-1"
        },
        styleBorderColor:{
            type: String,
            default: () => "var(--v-secondary-base);"
        },
        selectorProperties:{
            type: Object,
            default: () => (
                {
                    nameTitle: 'Sub-bacia',
                    nameProperty: 'locationname'
                }
            )
        },
        showInMap:{
            type: Boolean,
            default: () => false
        }
    },
    data: ()=>({
        search: '',
        headers: [],
        items:[],
    }),
    mounted(){
        this.initialize();
    },
    computed:{
        datesEstimation(){
            return eachDayOfInterval({
                start: subDays(Date.now(), this.minDaysForecast),
                end: Date.now()
            });
        },
        datesPrevision(){
            return eachDayOfInterval({
                start: Date.now(),
                end: addDays(Date.now(), this.maxDaysForecast)
            });
        }
    },
    watch:{
        locations(){
            this.initialize();
        },
    },
    methods:{
        initialize(){
            this.initializationHeaders();
            this.initializationItems();
        },

        initializationHeaders(){

            this.headers = [];

            if(!this.showInMap){
                this.headers = [
                    {
                        text: this.selectorProperties.nameTitle,
                        value: this.selectorProperties.nameProperty,

                        align: 'start',
                        class: `white--text ${this.selectorClassColor}`,
                        visibility: 'd-flex'
                    },
                ]
            }

            this.datesEstimation.forEach(date => {
                this.headers.push({
                    text: format(date, "dd/MM"),
                    value: `${format(date, "dd_MM")}E`,
                    sortable: true,
                    align: 'center',
                    class: `white--text item-rain-table ${this.estimationClassColor}`
                });
            });

            this.datesPrevision.forEach(date => {
                this.headers.push({
                    text: format(date, "dd/MM"),
                    value: `${format(date, "dd_MM")}P`,
                    sortable: true,
                    align: 'center',
                    class: `white--text item-rain-table ${this.forecastClassColor}`
                });
            });
        },

        initializationItems(){
            this.items = Object.assign([],this.locations);
            this.items = this.items.length > 0 ? this.items.map((location) => this.createTableItemObject(location)) : [this.createTableItemObject()];
        },

        createTableItemObject(location){
            const estimation = this.siprecDailyEstimated;
            let listEstimation = {};

            this.datesEstimation.forEach((date) => {
                const findEstimate = estimation ? estimation.find((estimate) => isEqual(parseISO(estimate.date), date)) : undefined;
                const formatDate = `${format(date, 'dd_MM')}E`;
                listEstimation[formatDate] = findEstimate ? Number(findEstimate.value.precIntensity).toFixed(1) : '--'
            });

            const previsions = location ? this.forecasts.find((forecast) => forecast.sourceid === 22 && forecast.locationid === location.locationid) : undefined;
            let listPrevision = {};

            this.datesPrevision.forEach((date) => {
                const findPrevision = previsions ? previsions.value.find((prevision) => isEqual(parseISO(prevision.date), date)) : undefined;
                const formatDate = `${format(date, 'dd_MM')}P`;
                listPrevision[formatDate] = findPrevision ? Number(findPrevision.precIntensity).toFixed(1) : '--'
            });

            let itemObj = {};

            if(!this.showInMap){
                itemObj[`${this.selectorProperties.nameProperty}`] = location[`${this.selectorProperties.nameProperty}`]
            }

            return {
                ...itemObj,
                ...listEstimation,
                ...listPrevision
            }
        },

        rest(index){
            return index % 2;
        },

        borderStyle(indexColumn){
            const borderColor = `4px solid ${this.styleBorderColor}`;
            const borderLeft = this.showInMap ? 0 : 1;
            const borderRight = this.showInMap ? this.minDaysForecast : this.minDaysForecast + 1;

            return indexColumn === borderLeft? `border-left: ${borderColor}` : indexColumn === borderRight ? `border-right: ${borderColor}` : '';
        }
    }
}
</script>

<style scoped>
    .header-rain-table{
        background-color: var(--v-primary-darken1);
        padding: 20px !important;
    }

    #header-estimation-rain-table{
        border-top: 6px solid var(--v-blue-base);
        border-left: 1px solid rgba(0, 0, 0, 0.2);
        border-right: 1.5px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px 5px 0px 0px;
        box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.2);
    }

    #header-prevision-rain-table{
        border-top: 6px solid var(--v-blue-darken1);
        border-right: 1px solid rgba(0, 0, 0, 0.2);
        border-left: 1.5px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px 5px 0px 0px;
        box-shadow: -2px 3px 4px rgba(0, 0, 0, 0.2);
    }

    #data-table-rain-forecast /deep/ .item-rain-table{
        border: 1px solid #2D324F !important;
        padding: 0px 20px !important;
    }

    #data-table-rain-forecast ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
    }

    #data-table-rain-forecast ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    #data-table-rain-forecast ::-webkit-scrollbar-thumb {
        background: darkgrey;
    }

    #data-table-rain-forecast ::-webkit-scrollbar-thumb:hover {
        background: grey;
    }
</style>